import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Space } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import {
  XMobDrawer,
  XMobHamburger,
  XMobHeader,
  XMobMenuList,
  XMobMenuItem,
} from "./MobHeaderStyle";
import HeaderTop from "./HeaderTop";

const menuItems = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: "/images/home-icon.svg",
    route: "/",
  },
  {
    key: "projects",
    label: "Library",
    icon: "/images/projects-icon.svg",
    route: "/projects/",
  },
  {
    key: "insights",
    label: "Analyze",
    icon: "/images/system-icon.svg",
    route: "/insight-engine/",
  },
  {
    key: "survey",
    label: "Survey Builder",
    icon: "/images/surveys-icon.svg",
    route: "/surveys/",
  },
  {
    key: "aijdv",
    label: "Design",
    icon: "/images/matrix-icon.svg",
    route: "/polling-agents/",
  },
  {
    key: "campaigns",
    label: "Launch",
    icon: "/images/matrix-icon.svg",
    route: "/campaigns/",
  },
  {
    key: "insightday",
    label: "Insight of the Day",
    icon: "/images/light-icon.svg",
    route: "/insight-of-day/",
  },
];

const MobHeader = () => {
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(!open);
  };
  const onClose = () => {
    setOpen(false);
  };

  return (
    <XMobHeader>
      <Row align="middle">
        <Col span={7}>
          <XMobHamburger onClick={showDrawer}>
            {/* <MenuUnfoldOutlined /> */}
            <MenuOutlined />
          </XMobHamburger>
        </Col>
        <Col span={8} className="text-center">
          <Link to="/">
            <img
              className="m-auto"
              style={{ height: 50 }}
              src="/images/logo.svg"
              alt="logo"
            />
          </Link>
        </Col>
        <Col span={9} className="text-end">
          <HeaderTop />
        </Col>
      </Row>
      <XMobDrawer
        title={false}
        closable={{ "aria-label": "Close Button" }}
        onClose={onClose}
        open={open}
        placement="left"
        zIndex={90}
        width={250}
      >
        {/* Navigation Menu */}
        <XMobMenuList>
          {menuItems.map((item) => (
            <XMobMenuItem key={item.key}>
              <Link to={item.route} onClick={onClose}>
                <Space>
                  <img src={item.icon} alt={item.label} />
                  {item.label}
                </Space>
              </Link>
            </XMobMenuItem>
          ))}
        </XMobMenuList>
      </XMobDrawer>
    </XMobHeader>
  );
};

export default MobHeader;
